import { ENDPOINT } from '~/constants/endpoints';

import type { UUID } from '~/types/common';

import { vestigasApi } from '~/services/kyClient';

import { zodDeleteTaxCodeEndpointSchema } from './validations';

/**
 * Deletes one tax code.
 *
 * @param taxCodeId - The tax code id.
 * @see https://app.dev.vestigas.com/redoc#tag/Tax-Codes
 */
export const deleteTaxCode = async (taxCodeId: UUID): Promise<void> => {
  await vestigasApi.delete(ENDPOINT.TAX_CODE.DELETE(taxCodeId), {
    validate: {
      pathSegments: zodDeleteTaxCodeEndpointSchema,
      // A 204 response has no JSON body to validate.
    },
  });
};
